"use strict";

import { ConfigMixin } from "@/mixins/config-mixin";
import { getAppFeatureProp } from "@/utilities/app-feature-util";
import CookieUtil from "@/utilities/cookie-util";
import GlobalTopic from "@/utilities/global-topic";
import { serializeVuetifyLocale, loadLocale } from "@/utilities/locale-util";

import { Constants } from "customer-sdk/constants";

const EVENTS = Constants.EVENTS;
export const LocaleMixin = {
  mixins: [ConfigMixin],
  data() {
    return {
      localizationEnabled: false,
      isLocalizationLoading: false,
    };
  },
  methods: {
    async changeLocale(locale) {
      if (this.localizationEnabled) {
        // Update language parameter when language is updated
        let language = "EN";
        if (locale == "zh") {
          language = "HK";
        }
        this.$router.push({
          path: this.$route.path,
          query: { ...this.$route.query, lang: language },
        });

        const cookieName = "_locale";
        const localeCookie = CookieUtil.getCookie(cookieName);
        if (!localeCookie || localeCookie !== locale) {
          CookieUtil.setCookie(cookieName, locale, 365);
        }

        if (!this.loadedLanguages.includes(locale)) {
          this.isLocalizationLoading = true;
          await loadLocale(this, locale);
          this.isLocalizationLoading = false;
          // Reload page when new locale added
          location.reload();
        } else {
          this.$i18n.locale = locale;
          this.$vuetify.lang.current = serializeVuetifyLocale(locale);
        }

        GlobalTopic.publishChange({
          type: EVENTS.ON_LOCALE_CHANGE,
          data: {
            locale: locale,
          },
        });
      } else {
        console.warn(`Trying to change locale to ${locale} while localization is disabled`);
      }
    },
    updateLocalizationToggle() {
      const toggle = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "localization");
      if (toggle) {
        this.localizationEnabled = toggle.enabled || false;
      }
    },
  },
  created() {
    this.updateLocalizationToggle();
  },
};
